import { useCallback, useEffect, useState, useRef } from "react";
import { fetchFastApi } from "../api/fastapi";
import { toast } from "sonner";
import {
  ReportExtractionSchemaItem,
  ReportExtractionSchemaItemType,
} from "../models/reportExtraction";
import { z } from "zod";

interface UseReportExtractionSchemasProps {
  fetchOnLoad?: boolean;
}

export const useReportExtractionSchemas = ({
  fetchOnLoad = false,
}: UseReportExtractionSchemasProps) => {
  const [schemas, setSchemas] = useState<ReportExtractionSchemaItemType[]>([]);
  const [loading, setLoading] = useState(false);
  const hasFetched = useRef(false);

  const fetchSchemas = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetchFastApi({
        method: "GET",
        path: "/report-extractions/schemas",
      });
      // Handle both direct array response and wrapped response
      const schemasArray = Array.isArray(response)
        ? response
        : response.schemas;
      const data = z.array(ReportExtractionSchemaItem).parse(schemasArray);
      setSchemas(data);
    } catch (error) {
      console.error(error);
      toast.error("Error fetching report extraction schemas");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (fetchOnLoad && !hasFetched.current) {
      fetchSchemas();
      hasFetched.current = true;
    }
  }, [fetchOnLoad, fetchSchemas]);

  return { schemas, loading, fetchSchemas };
};
